<template>
  <b-modal id="ModalInvoice" size="xl" ref="ModalInvoice" title="인보이스">
    <div id="invoiceDiv">
      <b-row class="mt-3">
        <b-colxx xxs="12">
          <b-row align-h="center">
            <b-col align-self="center" style="text-align: center"><b-img src="/assets/img/icon_logo.png"></b-img></b-col>
          </b-row>
        </b-colxx>
      </b-row>
      <b-row class="mb-2">
        <b-colxx xxs="12">
          사용기간 : {{startDate}} ~ {{endDate}}
        </b-colxx>
      </b-row>
      <b-row>
        <b-colxx xxs="12">
          <b-table-simple>
            <b-thead head-variant="light">
              <b-tr>
                <template v-for="(field , idx ) in fields">
                  <b-th style="text-align:center">{{field.label}}</b-th>
                </template>
              </b-tr>
            </b-thead>
            <b-tbody>
              <template v-for="(item , index ) in items">
                <b-tr>
                  <b-td style="text-align: center">{{index + 1}}</b-td>
                  <b-td style="text-align: center">{{item.storeNmae}}</b-td>
                  <b-td style="text-align: center">{{item.goodsName}}</b-td>
                  <b-td style="text-align: center">{{item.count | currency }}</b-td>
                  <b-td style="text-align: center">{{item.listPrice | currency }}</b-td>
                  <b-td style="text-align: center">{{item.salePrice | currency }}</b-td>
                  <b-td style="text-align: center">{{item.netPrice | currency }}</b-td>
                  <b-td style="text-align: center">{{item.commission | currency }}</b-td>
                </b-tr>
              </template>
            </b-tbody>
            <b-tfoot>
              <b-tr>
                <b-th colspan="3" style="text-align: center;background:#f6c797 !important">Total</b-th>
                <b-th style="text-align: center;background:#f6c797 !important">{{ countTotal | currency }}</b-th>
                <b-th style="text-align: center;background:#f6c797 !important">{{ listPriceTotal | currency }}</b-th>
                <b-th style="text-align: center;background:#f6c797 !important">{{ salePriceTotal | currency}}</b-th>
                <b-th style="text-align: center;background:#f6c797 !important">{{ netPriceTotal | currency }}</b-th>
                <b-th style="text-align: center;background:#f6c797 !important">{{ commissionTotal | currency}}</b-th>
              </b-tr>
            </b-tfoot>
          </b-table-simple>
        </b-colxx>
      </b-row>
      <b-row>
        <b-colxx xxs="12">
            <b-table-simple :borderless="true">
              <b-tr>
                <b-td align="center">사업자등록번호 113-86-37001</b-td>
              </b-tr>
              <b-tr>
                <b-td align="center">서울시 구로구 디지털로 26길 61 에이스하이엔드타워 2차 403호</b-td>
              </b-tr>
              <b-tr>
                <b-td align="center">
                  www.tablenjoy.com<br/>(주) 테이블엔조이
                  <b-img src="/assets/img/stamp.jpg" style="width:70px;"></b-img>
                </b-td>
              </b-tr>
            </b-table-simple>
        </b-colxx>
      </b-row>
    </div>
    <template slot="modal-footer">
      <b-button variant="outline-primary" @click="hideModal">닫기</b-button>
      <b-button variant="warning" @click="makePrint">인쇄하기</b-button>
      <b-button variant="primary" @click="makePDF" class="mr-1">PDF저장</b-button>
    </template>
  </b-modal>

</template>
<script>
  import {
    mapGetters,
  } from "vuex";
  import {currencyFilter} from "../../../utils";
  import html2canvas from 'html2canvas'
  import jsPDF from 'jspdf'

  export default {
    components: {},
    name: "Invoice",
    filters: {...currencyFilter},
    props: [],
    data() {
      return {
        invoiceName: null,
        startDate: null,
        endDate: null,
        fields: [
          {key: 'no', label: '번호'},
          {key: 'storeName', label: '매장명'},
          {key: 'goodsName', label: '상품명'},
          {key: 'count', label: '수량'},
          {key: 'listPrice', label: '정상가'},
          {key: 'salePrice', label: '판매가'},
          {key: 'netPrice', label: '입금가'},
          {key: 'commission', label: '수수료'},
        ],
        items: [
          {
            storeNmae: '강남점 ',
            goodsName: '상품옵션',
            count: 40,
            listPrice: 500000,
            salePrice: 450000,
            netPrice: 400000,
            commission: 50000,
          },
          {
            storeNmae: '청담점 ',
            goodsName: '상품옵션2',
            count: 40,
            listPrice: 500000,
            salePrice: 450000,
            netPrice: 400000,
            commission: 50000,
          }
        ],
      }
    },
    computed: {
      ...mapGetters(['currentUser', 'siteName']),
      countTotal() {
        return this.items.reduce((accum, item) => {
          return accum + item.count
        }, 0.0)
      },
      listPriceTotal() {
        return this.items.reduce((accum, item) => {
          return accum + item.listPrice
        }, 0.0)
      },
      salePriceTotal() {
        return this.items.reduce((accum, item) => {
          return accum + item.salePrice
        }, 0.0)
      },
      netPriceTotal() {
        return this.items.reduce((accum, item) => {
          return accum + item.netPrice
        }, 0.0)
      },
      commissionTotal() {
        return this.items.reduce((accum, item) => {
          return accum + item.commission
        }, 0.0)
      }

    },
    mounted() {

    },
    methods: {
      open(month) {
        this.invoiceName = this.$moment(month).format('YYYY년MM월')
        this.startDate = this.$moment(month).format('YYYY-MM-01')
        this.endDate = this.$moment(new Date(month.getFullYear(), month.getMonth() + 1, 0)).format('YYYY-MM-DD')
        this.$refs['ModalInvoice'].show()
      },
      hideModal() {
        this.$refs['ModalInvoice'].hide()
      },
      makePrint() {
        this.$htmlToPaper('invoiceDiv')
      },
      makePDF() {
        window.html2canvas = html2canvas //Vue.js 특성상 window 객체에 직접 할당해야한다.
        let that = this
        let pdf = new jsPDF('p', 'mm', 'a4')

        // window.scrollTo(0, 0)

        let canvas = pdf.canvas
        const pageWidth = 190 //캔버스 너비 mm
        const pageHeight = pageWidth * 1.414 //캔버스 높이 mm
        canvas.width = pageWidth
        let ele = document.querySelector('#invoiceDiv')

        let width = ele.offsetWidth // 셀렉트한 요소의 px 너비
        let height = ele.offsetHeight // 셀렉트한 요소의 px 높이
        let imgHeight = pageWidth * height / width // 이미지 높이값 px to mm 변환

        if (!ele) {
          console.warn(selector + ' is not exist.')
          return false
        }

        html2canvas(ele, { useCORS: true } ).then( canvas => {
            let position = 10
            const imgData = canvas.toDataURL('image/png')
            // let newData = imgData.replace(/^data:image\/png/, "data:application/octet-stream");

            pdf.addImage(imgData, 'png', 10 , position, pageWidth, imgHeight, undefined, 'slow')
            //Paging 처리
            let heightLeft = imgHeight //페이징 처리를 위해 남은 페이지 높이 세팅.
            heightLeft -= pageHeight
            while (heightLeft >= 0) {
              position = heightLeft - imgHeight
              pdf.addPage();
              pdf.addImage(imgData, 'png', 10, position, pageWidth, imgHeight)
              heightLeft -= pageHeight
            }
            pdf.save(that.invoiceName + '.pdf')
        });

      }
    }
  }
</script>
